import { RequestStatus } from 'clickNgo/configs/service/common'

import { IGlobalPartnerState } from './models/iGlobalPartnerState'

export const initialState: IGlobalPartnerState = {
  data: null,
  status: RequestStatus.FULFILLED,
  message: '',
}
